import React, { useEffect, useRef, useState } from 'react';
import HomeBanner from '../components/home-banner/HomeBanner';
import FeatureInfo from '../components/FeatureInfo';
import CourseCategoryList from '../components/course/CourseCategoryList';
import PackageList from '../components/PackageList';
import WelcomeSection from '../components/WelcomeSection';
import StatisticsSection from '../components/StatisticsSection';
import AchieversSection from '../components/AchieversSection';
import Testimonials from '../components/Testimonials';
import Header from '../components/Header';
import { dashboard } from '../handler/LoginAndSingupHandler';
import CourseList from '../components/CourseList';
import UserLoaderVideo from '../Dashboard/UserLoaderVideo';
import banner from "../Photos/Banner/HomeBanner.png"
import { NativeBiometric } from 'capacitor-native-biometric';
import { Capacitor } from '@capacitor/core';
const HomePage = () => {
    const [loader, setLoader] = useState(true);
    const [statistics, setStatistics] = useState({
        students: 0,
        courses: 0,
        teachers: 0,
        awards: 0,
    });
    const runOnce = useRef(false);
    const dashboardApi = async () => {
        var response = await dashboard();
        if (response.statusCode === 200) {
            setStatistics(response.data.dashboard.statistics);
        }
        setTimeout(() => {
            setLoader(false);
        }, 3000);
    }
    const [showBanner, setShowBanner] = useState(true);
    useEffect(() => {
        if (runOnce.current === false) {
            dashboardApi();
            runOnce.current = true;
        }
    }, [runOnce])
    const loginWithBiometric = async () => {
        try {
            setLoader(true);
            await NativeBiometric.verifyIdentity({
                reason: "Log in securely",
                title: "Biometric Login",
                subtitle: "Use fingerprint, face, or device PIN",
                description: "Authenticate to access your account",
                // 👇 this enables screen lock fallback
                useFallback: true
            });
            window.location.href = "/mycourses"

        } catch (err) {
            // ❌ Authentication failed or user canceled
            console.error("Authentication failed", err);
            setLoader(false);
        }
        setLoader(false);
    }
    useEffect(() => {
        if (Capacitor.getPlatform() === "android") {
            setLoader(true);
            const appKey = localStorage.getItem("appkey");
            if (appKey !== null) {
                loginWithBiometric();
            }
            setLoader(false);
        }
    }, []);

    return <>
        {
            loader ? <UserLoaderVideo /> :
                <>
                    <section onClick={() => { setShowBanner(false) }}>
                        {showBanner && (<>
                            <>
                                <section>
                                    <div style={{ background: "rgba(0, 0, 0, .5)", position: "fixed", height: "100%", width: "100%", left: "0", top: "0", zIndex: 1000 }}>
                                        <img src={banner} className='banner' />
                                    </div>
                                </section>
                            </>
                        </>)}
                        <Header />
                        <HomeBanner />
                        <FeatureInfo />
                        <WelcomeSection />
                        <CourseCategoryList />
                        <StatisticsSection statistics={
                            {
                                students: statistics.students + 1000,
                                courses: statistics.courses,
                                teachers: statistics.teachers,
                                awards: statistics.awards,
                            }
                        } />
                        <PackageList />
                        <AchieversSection />
                        <CourseList />
                        <Testimonials />
                    </section>
                </>
        }
    </>
};

export default HomePage;